<script setup lang="ts">
const route = useRoute()
</script>

<template>
  <main class="flex h-full items-center justify-center">
    <div class="p-6">
      [file: pages/microcredit/[company]/map/[...type].vue, params:
      {{ route.params.type || 'null' }}]
    </div>
  </main>
</template>
